import React, { useState, useRef, useEffect } from 'react';

export const InfoCircle = ({ description }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipRef = useRef(null);
    const handleToggleTooltip = () => {setShowTooltip((prev) => !prev);};

    // Close the tooltip on a click outside of it, listening only while it's open
    useEffect(() => {
        if (!showTooltip) return;

        const handleClickOutside = (event) => {
          if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
            setShowTooltip(false);
          }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [showTooltip]);

    return (
        <div className="relative inline-block" ref={tooltipRef}>

            {/* Info Circle */}
            <div onClick={handleToggleTooltip} className="select-none rounded-full cursor-pointer flex items-center justify-center text-xs sm:text-lg size-5 sm:size-8 bg-white text-black dark:bg-stone-600 dark:text-white">
                i
            </div>

            {/* Tooltip */}
            {showTooltip && (
                <div className="absolute bottom-full mb-2 left-1/6 transform -translate-x-1/3 px-4 py-2 bg-stone-800 text-white text-xs sm:text-sm sm:w-34 rounded-xl shadow-lg">
                    {description}
                </div>
            )}

        </div>
    );
}
